<ngx-spinner type="ball-atom"></ngx-spinner>
<div class="component-container">
  <div class="component-header">
    <h2>Honorific Titles</h2>
    <div class="button-group">
      <button mat-raised-button color="primary" (click)="onCreateHonorificTitle()">
        <mat-icon>add</mat-icon>
        Add Honorific Title
      </button>
    </div>
  </div>
  <app-lookup-table
      [items]="honorificTitles()"
      (itemClick)="onItemSelected($event)"
      (editClick)="onEditHonorificTitle($event)"
      (deleteClick)="onDeleteHonorificTitle($event)"
      (itemSave)="onItemSave($event)"
      (itemAdd)="onItemAdd($event)">
    </app-lookup-table>
</div>
